import clsx from 'clsx'
import { type ReactElement, useContext } from 'react'
import { Card } from '~/components/Global/Blocks/Card/Card'
import { AsideActionContext, HoverInfoContext } from '~/utils/contextes'
import { formatDateShort } from '~/utils/date'
import type { OrderShortlistFeedbackEntry } from '../queries/orderShortlistFeedbacks'
import {
  feedbackList,
  feedbackListTitle,
  feedbackRank,
  rankBadgeAnswer
} from './ShortlistRankBadge.css'
import { ShortlistReportAside } from './ShortlistReportAside'

type ShortlistFeedbackListProps = {
  feedbacks: OrderShortlistFeedbackEntry[]
}

export const ShortlistFeedbackList = ({
  feedbacks
}: ShortlistFeedbackListProps): ReactElement => {
  const { asideAction, setAsideAction } = useContext(AsideActionContext)
  const { close } = useContext(HoverInfoContext)

  return (
    <div className={feedbackList}>
      <div className={feedbackListTitle}>Retours clients</div>
      {feedbacks.map((entry) => (
        <Card
          key={entry.shortlistId}
          compact
          title={entry.contactName ?? 'Contact'}
          subtitle={[
            formatDateShort(new Date(entry.submittedAt)),
            entry.accepted === null
              ? null
              : entry.accepted
                ? 'Retenu'
                : 'Non retenu'
          ]
            .filter(Boolean)
            .join(' · ')}
          metaData={[
            <span
              key="rank"
              className={clsx(
                feedbackRank,
                rankBadgeAnswer[
                  entry.accepted === null
                    ? 'none'
                    : entry.accepted
                      ? 'yes'
                      : 'no'
                ]
              )}
            >
              {entry.rank}/{entry.total}
            </span>
          ]}
          onClick={(event) => {
            event.stopPropagation()
            close()
            setAsideAction({
              action: <ShortlistReportAside shortlistId={entry.shortlistId} />,
              returnTo: asideAction ?? undefined
            })
          }}
        />
      ))}
    </div>
  )
}
